export const apiConfig = {
  baseURL: '/api',
  responseType: 'json',
}
